<h1 class="d-none d-md-block">
    <ng-content></ng-content>
</h1>
